<template>
  <div class="link_01">
    <div class="jugadores-equipo avenirnextltpro-medium-big-stone-10px" @click="clickBreadCrumbs(1)">
      Jugadores - Equipo
    </div>
  </div>
</template>

<script>
export default {
  name: 'Link01',
  methods: {
    clickBreadCrumbs(id) {
      if (id == 1) {
        this.$router.push('/playersAnalysis/teams');
      }
    },
  },
};
</script>

<style>
.link_01,
.link_01-1,
.link_01-2,
.link_01-3 {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 2px 4px;
  position: relative;
  width: fit-content;
}

.jugadores-equipo,
.jugadores-equipo-1,
.jugadores-equipo-2,
.jugadores-equipo-3 {
  letter-spacing: -0.1px;
  line-height: 17px;
  margin-top: -2px;
  position: relative;
  text-align: center;
  text-decoration: underline;
  white-space: nowrap;
  width: fit-content;
}
.jugadores-equipo:hover {
  color: #23b0ff;
  cursor: pointer;
}
</style>
